// extracted by mini-css-extract-plugin
export default {"user-group":"IntegrationUserData_user-group__xvhOY"};